"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorSchemeMap = exports.avatarDefaultFontColor = void 0;
const colorSchemeMap = {
  light: {
    blue: 'blue60',
    teal: 'teal60',
    purple: 'purple60',
    pink: 'pink60',
    green: 'green60',
    gray: 'gray100'
  },
  dark: {
    blue: 'blue60',
    teal: 'teal60',
    purple: 'purple60',
    pink: 'pink60',
    green: 'green60',
    gray: 'gray60'
  }
};
exports.colorSchemeMap = colorSchemeMap;
const avatarDefaultFontColor = '#ffffff';
exports.avatarDefaultFontColor = avatarDefaultFontColor;